import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d[0]?.msg?.replace("Value error, ", "") || "Données invalides";
  return d || "Une erreur est survenue, merci de réessayer";
};

const REF_KEY = "oc_parrain";
export const saveRef = (code) => localStorage.setItem(REF_KEY, JSON.stringify({ code, at: Date.now() }));
export const getRef = () => {
  try { const r = JSON.parse(localStorage.getItem(REF_KEY)); return r && Date.now() - r.at < 90 * 864e5 ? r.code : ""; } catch { return ""; }
};

export const api = {
  referral: (code) => axios.get(`${API}/referral/${code}`).then((r) => r.data),
  referralLead: (code, b) => axios.post(`${API}/referral/${code}/lead`, b).then((r) => r.data),
  results: () => axios.get(`${API}/results`).then((r) => r.data),
  availability: (start, end) => axios.get(`${API}/availability`, { params: { start, end } }).then((r) => r.data),
  appointment: (b) => axios.post(`${API}/appointments`, { ...b, ref: getRef() }).then((r) => r.data),
  message: (b) => axios.post(`${API}/messages`, { ...b, ref: getRef() }).then((r) => r.data),
  simulation: (b) => axios.post(`${API}/simulations`, { ...b, ref: getRef() }).then((r) => r.data),
  manage: (t) => axios.get(`${API}/appointments/manage/${t}`).then((r) => r.data),
  manageCancel: (t) => axios.post(`${API}/appointments/manage/${t}/cancel`).then((r) => r.data),
  manageMove: (t, b) => axios.post(`${API}/appointments/manage/${t}/reschedule`, b).then((r) => r.data),
  contractPreview: (b) => axios.post(`${API}/contracts/preview`, b).then((r) => r.data),
  contractStart: (b) => axios.post(`${API}/contracts`, b).then((r) => r.data),
  contractView: (t) => axios.get(`${API}/contracts/sign/${t}`).then((r) => r.data),
  contractCode: (t) => axios.post(`${API}/contracts/sign/${t}/code`).then((r) => r.data),
  contractSign: (t, b) => axios.post(`${API}/contracts/sign/${t}`, b).then((r) => r.data),
  newsletter: (b) => axios.post(`${API}/newsletter`, b).then((r) => r.data),
  cityContent: (slug) => axios.get(`${API}/cities/content/${slug}`).then((r) => r.data),
};

const TK = "oc_admin_token";
const auth = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem(TK) || ""}` } });
export const admin = {
  token: () => sessionStorage.getItem(TK),
  logout: () => sessionStorage.removeItem(TK),
  login: (password) => axios.post(`${API}/admin/login`, { password }).then((r) => { sessionStorage.setItem(TK, r.data.token); return r.data; }),
  stats: () => axios.get(`${API}/admin/stats`, auth()).then((r) => r.data),
  list: (kind) => axios.get(`${API}/admin/requests`, { ...auth(), params: { kind } }).then((r) => r.data),
  status: (kind, id, status) => axios.patch(`${API}/admin/requests/${kind}/${id}`, { status }, auth()).then((r) => r.data),
  remove: (kind, id) => axios.delete(`${API}/admin/requests/${kind}/${id}`, auth()).then((r) => r.data),
  blocked: () => axios.get(`${API}/admin/blocked-days`, auth()).then((r) => r.data),
  block: (date, reason) => axios.post(`${API}/admin/blocked-days`, { date, reason }, auth()).then((r) => r.data),
  contractPdf: (id) => axios.get(`${API}/admin/contracts/${id}/pdf`, { ...auth(), responseType: "blob" }).then((r) => r.data),
  cities: () => axios.get(`${API}/admin/cities`, auth()).then((r) => r.data),
  citySave: (slug, b) => axios.put(`${API}/admin/cities/${slug}`, b, auth()).then((r) => r.data),
  cityGenerate: (slug) => axios.post(`${API}/admin/cities/${slug}/generate`, {}, auth()).then((r) => r.data),
  unblock: (date) => axios.delete(`${API}/admin/blocked-days/${date}`, auth()).then((r) => r.data),
};

const OK = "oc_owner_token";
const oauth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem(OK) || ""}` } });
const g = (u, p) => axios.get(`${API}${u}`, { ...oauth(), params: p }).then((r) => r.data);
export const owner = {
  token: () => localStorage.getItem(OK),
  logout: () => localStorage.removeItem(OK),
  login: (b) => axios.post(`${API}/owner/login`, b).then((r) => { localStorage.setItem(OK, r.data.token); return r.data; }),
  setPassword: (b) => axios.post(`${API}/owner/password`, b).then((r) => r.data),
  forgot: (email) => axios.post(`${API}/owner/forgot`, { email }).then((r) => r.data),
  me: () => g("/owner/me"),
  month: (pid, m) => g(`/owner/properties/${pid}/month`, { m }),
  year: (pid, y) => g(`/owner/properties/${pid}/year`, { y }),
  upcoming: (pid) => g(`/owner/properties/${pid}/upcoming`),
  block: (pid, b) => axios.post(`${API}/owner/properties/${pid}/blocks`, b, oauth()).then((r) => r.data),
  unblock: (pid, bid) => axios.delete(`${API}/owner/properties/${pid}/blocks/${bid}`, oauth()).then((r) => r.data),
  statement: (pid, m) => axios.get(`${API}/owner/properties/${pid}/statement/${m}`, { ...oauth(), responseType: "blob" }).then((r) => r.data),
  documents: () => g("/owner/documents"),
  documentPdf: (cid) => axios.get(`${API}/owner/documents/${cid}/pdf`, { ...oauth(), responseType: "blob" }).then((r) => r.data),
  tickets: () => g("/owner/tickets"),
  ticket: (b) => axios.post(`${API}/owner/tickets`, b, oauth()).then((r) => r.data),
  files: () => g("/owner/files"),
  referral: () => g("/owner/referral"),
  fileDl: (id) => axios.get(`${API}/owner/files/${id}/download`, { ...oauth(), responseType: "blob" }).then((r) => r.data),
  works: () => g("/owner/works"),
  newWork: (b) => axios.post(`${API}/owner/works`, b, oauth()).then((r) => r.data),
  decide: (id, b) => axios.post(`${API}/owner/works/${id}/decision`, b, oauth()).then((r) => r.data),
  workPdf: (id, kind) => axios.get(`${API}/owner/works/${id}/pdf/${kind}`, { ...oauth(), responseType: "blob" }).then((r) => r.data),
};
export const saveBlob = (blob, name) => { const u = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = u; a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(u), 2000); };
export const eur = (x) => (x || 0).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

export const adminOwners = {
  list: () => axios.get(`${API}/admin/owners`, auth()).then((r) => r.data),
  create: (b) => axios.post(`${API}/admin/owners`, b, auth()).then((r) => r.data),
  invite: (id) => axios.post(`${API}/admin/owners/${id}/invite`, {}, auth()).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/admin/owners/${id}`, auth()).then((r) => r.data),
  addProp: (id, b) => axios.post(`${API}/admin/owners/${id}/properties`, b, auth()).then((r) => r.data),
  editProp: (pid, b) => axios.put(`${API}/admin/properties/${pid}`, b, auth()).then((r) => r.data),
  delProp: (pid) => axios.delete(`${API}/admin/properties/${pid}`, auth()).then((r) => r.data),
  rooms: () => axios.get(`${API}/admin/beds24/rooms`, auth()).then((r) => r.data),
  tickets: () => axios.get(`${API}/admin/tickets`, auth()).then((r) => r.data),
  ticketStatus: (id, status) => axios.patch(`${API}/admin/tickets/${id}`, { status }, auth()).then((r) => r.data),
  files: (oid) => axios.get(`${API}/admin/owners/${oid}/files`, auth()).then((r) => r.data),
  referrals: () => axios.get(`${API}/admin/referrals`, auth()).then((r) => r.data),
  referralStatus: (id, status) => axios.patch(`${API}/admin/referrals/${id}`, { status }, auth()).then((r) => r.data),
  results: () => axios.get(`${API}/admin/results`, auth()).then((r) => r.data),
  newResult: (b) => axios.post(`${API}/admin/results`, b, auth()).then((r) => r.data),
  editResult: (id, b) => axios.put(`${API}/admin/results/${id}`, b, auth()).then((r) => r.data),
  delResult: (id) => axios.delete(`${API}/admin/results/${id}`, auth()).then((r) => r.data),
  runFollowups: () => axios.post(`${API}/admin/followups/run`, {}, auth()).then((r) => r.data),
  upload: (oid, fd, onUploadProgress) => axios.post(`${API}/admin/owners/${oid}/files`, fd, { ...auth(), onUploadProgress }).then((r) => r.data),
  fileDl: (id) => axios.get(`${API}/admin/files/${id}/download`, { ...auth(), responseType: "blob" }).then((r) => r.data),
  delFile: (id) => axios.delete(`${API}/admin/files/${id}`, auth()).then((r) => r.data),
  works: () => axios.get(`${API}/admin/works`, auth()).then((r) => r.data),
  newWork: (b) => axios.post(`${API}/admin/works`, b, auth()).then((r) => r.data),
  quote: (id, b) => axios.put(`${API}/admin/works/${id}/quote`, b, auth()).then((r) => r.data),
  workStatus: (id, b) => axios.patch(`${API}/admin/works/${id}/status`, b, auth()).then((r) => r.data),
  invoice: (id) => axios.post(`${API}/admin/works/${id}/invoice`, {}, auth()).then((r) => r.data),
  workPdf: (id, kind) => axios.get(`${API}/admin/works/${id}/pdf/${kind}`, { ...auth(), responseType: "blob" }).then((r) => r.data),
  delWork: (id) => axios.delete(`${API}/admin/works/${id}`, auth()).then((r) => r.data),
  cleanings: () => axios.get(`${API}/admin/cleanings`, auth()).then((r) => r.data),
  cleaningStatus: (id, status) => axios.patch(`${API}/admin/cleanings/${id}`, { status }, auth()).then((r) => r.data),
};
